import React, { useEffect, useState, useMemo, useContext } from "react";
import Select from "react-select";
import { useProjectMembers } from "../queries/use-project-members";
import { useMembers } from "../queries/use-members";
import { AuthContext } from "../context/AuthContext";
import { useEditProjectMembers } from "../queries/use-edit-project-members";

const EditProjectMembersPopup = ({ projectId, onClose }) => {
  const { authState } = useContext(AuthContext);
  const { data: members } = useProjectMembers(projectId);
  const { data: allMembers } = useMembers(projectId);
  const [selected, setSelected] = useState([]);
  const { mutateAsync, isLoading } = useEditProjectMembers(projectId);

  const options = useMemo(
    () =>
      members
        ?.filter((m) => m.id !== authState.userInfo.id)
        .map((m) => ({ label: m.email, value: m.id })),
    [members, authState.userInfo.id]
  );

  const allOptions = useMemo(
    () =>
      allMembers
        ?.filter((m) => m.id !== authState.userInfo.id)
        .map((m) => ({ label: m.email, value: m.id })),
    [allMembers, authState.userInfo.id]
  );

  useEffect(() => {
    setSelected(options);
  }, [options]);

  const submit = async (e) => {
    e.preventDefault();
    await mutateAsync([authState.userInfo.id, ...selected.map((s) => s.value)]);
    onClose();
  };

  if (!members || !allMembers) {
    return <div />;
  }

  const handleChange = (selected) => {
    setSelected(selected);
  };

  return (
    <div
      className="fixed z-10 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        />

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block align-bottom bg-white rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <form onSubmit={submit}>
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div>
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <h3
                    className="text-lg leading-6 font-medium text-gray-900"
                    id="modal-title"
                  >
                    Edit Project
                  </h3>
                  <div className="mt-2 text-sm text-gray-500">
                    <label className="block text-sm font-medium text-gray-700">
                      Members
                    </label>
                    <div className="mt-1 flex rounded-md shadow-sm">
                      <Select
                        className="w-full border-gray-300"
                        closeMenuOnSelect={false}
                        isMulti
                        onChange={handleChange}
                        options={allOptions}
                        value={selected}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <button
                type="submit"
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
              >
                Save
              </button>
              <button
                type="button"
                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                onClick={() => onClose()}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditProjectMembersPopup;
